<template>
  <div :style="{ width: viewPort.width + 'px', height: viewPort.height + 'px' }">

    <div class="panolens" :class="[
      {'border-expanded': isBorderExpanded},
      {'border-full': isMapOpen},
      {'grabbing': isDown}]"
      >
      <div v-if="currentRoom" class="hotspot-reference">
        <div
          v-for="(hotspot, index) in currentRoom.hotspotInfo"
          :key="'info'+index"
          :ref="'hotspot-info'+index"
          class="hotspot-info"
        >
          <HotspotHtml
            v-if="hotspot"
            :small="currentRoom.hotspotInfo.length > 5"
            :hotspot="hotspot.hotspot"
            :room="currentRoom"
            :position="hotspot.position"
          />
        </div>
      </div>

      <div v-if="currentRoom" class="hotspot-reference">
        <div class="hotspot-multiproduct" v-for="(hotspot, index) in currentRoom.hotspotMultiProduct"
          :key="'multiproduct'+index"
          :ref="'hotspot-multiproduct'+index"
        >
          <HotspotHtml
            v-if="hotspot"
            :small="currentRoom.hotspotMultiProduct.length > 5"
            :room="currentRoom"
            :hotspot="hotspot.hotspot" />
        </div>
      </div>

      <div v-if="currentRoom" class="hotspot-reference">
        <div class="hotspot-room" v-for="(hotspotroom, index) in currentRoom.hotspotRoom"
            :key="'room'+index"
            :ref="'hotspot-room'+index"
          >
          <h4 v-if="hotspotroom && hotspotroom.position.indexOf('archetypes') !== -1"><ArchetypesSvg class="archetypes-logo" /></h4>
          <h4 v-if="hotspotroom && hotspotroom.position.indexOf('boutique') !== -1">{{$root.allLanguages[$route.params.language].boutique}}</h4>
          <h4 v-if="hotspotroom && hotspotroom.position.indexOf('bookstore') !== -1">{{$root.allLanguages[$route.params.language].bookstore}}</h4>
          <HotspotRoomHtml
            @onClick="hotspotClick"
            :hotspot="hotspotroom"
          />
        </div>
      </div>

      <!-- Room Video File Hotspot -->
      <div v-if="currentRoom" class="video-box-container">
        <div class="video-box"
          :ref="'videobox' + index"
          :key="currentRoom._slug + hotspot.videoFile.id + index"
          :class="{'border': hotspot.position.indexOf('border') > -1}"
          v-for="(hotspot, index) in currentRoom.hotspotGif"
        >
          <div class="box">
            <ImageSequenceLoader
              v-if="hotspot && hotspot.videoFile.id.indexOf('zip') > -1"
              :url="'/media/' + hotspot.videoFile.id"
              :room="currentRoom"
            >
            </ImageSequenceLoader>
            <VideoPlayer
              v-if="hotspot && hotspot.videoFile.id.indexOf('mp4') > -1"
              :content="hotspot"
              :autoplay="true"
              :showPlayer="true"
              :loop="true"
              :showControl="false"
            />
            <img
              v-if="hotspot && (hotspot.videoFile.id.indexOf('jpg') > -1 || hotspot.videoFile.id.indexOf('gif') > -1 || hotspot.videoFile.id.indexOf('png') > -1)"
              :src="'/media/' + hotspot.videoFile.id"
            >
          </div>
        </div>
      </div>

      <div v-show="currentRoom" class="pano-container" ref="pano" @click="onPanoClick"></div>
      <div v-show="showVideoHotspot" :class="currentRoom && currentRoom.videoBlending ? 'video-blending' : ''" class="panovideo-container" ref="panovideo"></div>
      <div v-show="currentRoom" class="pano-hotspot-container" ref="panohotspot"></div>

      <transition name="fade">
        <div class="video-overlay" v-show="showVideoOverlay">
          <VideoPlayer
            v-if="videoOverlay"
            :content="videoOverlay"
            :autoplay="true"
            :showPlayer="true"
            :loop="false"
            :cover="true"
            :showControl="false"
            :endBeforeEnd="true"
            :width="viewPort.width"
            :height="viewPort.height"
            @onVideoPlay="onVideoReady"
            @beforeEnd="onVideoFinished"
            @videoFinished="onVideoRemove"
          />
        </div>
      </transition>

      <transition name="fade">
        <div class="tutorial" v-if="showTutorial && isShowingTutorial">
          <transition name="fade">
            <div v-if="!showHotspotTutorial" class="tutorial-content absolute-center">
              <img :src="iconTutorial"/>
              <h2 class="c-white">{{$root.allLanguages[$route.params.language].drag}}</h2>
            </div>
          </transition>
          <transition name="fade">
            <div v-if="showHotspotTutorial" class="tutorial-content absolute-center">
              <img :src="iconTutorialHotspot"/>
              <h2 class="c-white">{{$root.allLanguages[$route.params.language].tutorialHotspot}}</h2>
            </div>
          </transition>
        </div>
      </transition>

      <div ref="panovideoui" v-if="showVideoUI && currentRoom && currentRoom.hotspotGif" class="ui-container">
        <PanolensVideoUI
          :key="'key'+index"
          v-for="(hotspot, index) in currentRoom.hotspotGif"
          :index="index"
          :position="hotspot.position"
          @update="onVideoUpdate" />
      </div>
    </div>
  </div>
</template>

<script>
import ImageSequenceLoader from '../atoms/ImageSequenceLoader.vue'
import VideoPlayer from '../atoms/VideoPlayer.vue'
import PanolensVideoUI from '../atoms/PanolensVideoUI.vue'

import { VideoPanorama, ImagePanorama, Viewer, Infospot, InfospotSprite } from 'panolens/build/panolens.module'

import GetRoom from '@/graphql/GetRoom.gql'
import GetHotspotInfo from '@/graphql/GetHotspotInfo.gql'
import GetHotspotMultiProduct from '@/graphql/GetHotspotMultiProduct.gql'

import HotspotHtml from '@/atoms/HotspotHtml'
import HotspotRoomHtml from '@/atoms/HotspotRoomHtml'
// import UserViewCompass from '@/atoms/UserViewCompass'
// import PanolensRoomList from '@/atoms/PanolensRoomList'
import { RAF } from '@monogrid/js-utils'
import { Viewport } from '@monogrid/vue-lib'
import floorArrow from '!!url-loader!@/assets/img/floor-arrow.png'//eslint-disable-line
import floorArrowLeft from '!!url-loader!@/assets/img/floor-arrow-left.png'//eslint-disable-line
import floorArrowRight from '!!url-loader!@/assets/img/floor-arrow-right.png'//eslint-disable-line
import infoCircle from '!!url-loader!@/assets/img/info-circle.png' //eslint-disable-line
import iconExit from '!!url-loader!@/assets/img/icon-exit.png' //eslint-disable-line

import iconTutorial from '@/assets/img/icon-tutorial-drag.png'
import iconTutorialHotspot from '@/assets/img/icon-tutorial-hotspot.png'

import ListFloor from '@/graphql/ListFloor.gql'
import { Scene, Vector3 } from 'three'
import { CSS3DObject, CSS3DRenderer } from 'three-css3drenderer'
import anime from 'animejs'

import ArchetypesSvg from '@/assets/svg/logo-archetypes.svg'

export default {
  name: 'Panolense360',
  mixins: [Viewport],
  data () {
    return {
      rooms: null,
      roomslugs: [],
      currentRoom: null,
      isBorderExpanded: false,
      isMapOpen: false,
      showVideoHotspot: false,
      isDown: false,
      floorArrow,
      floorArrowRight,
      floorArrowLeft,
      infoCircle,
      iconExit,
      isLoading: false,
      showTutorial: true,
      showHotspotTutorial: false,
      isShowingTutorial: false,
      showVideoUI: false,
      videoOverlay: null,
      showVideoOverlay: false,
      iconTutorialHotspot,
      iconTutorial
    }
  },

  components: {
    // PanolensRoomList,
    HotspotRoomHtml,
    HotspotHtml,
    PanolensVideoUI,
    VideoPlayer,
    ImageSequenceLoader,
    ArchetypesSvg
  },

  mounted () {
    this.minZoom = 70
    this.camRotationY = 0
    this.zoomDefault = this.minZoom
    this.currentFloor = null
    this.infospots = []
    this.newpanorama = null
    this.currentPanorama = null
    this.isVideoReady = false
    this.isFirstTutorial = false
    // console.log('panolens mounted', this.$apollo)
    RAF.add(this.update)
    // document.addEventListener('mousemove', this.onMouseUpdate)
    this.$events.on('onMapClose', () => { this.isMapOpen = false })
    this.$events.on('onMapOpen', () => { this.isMapOpen = true })
    this.$events.on('showTutorial', () => {
      if (!this.isFirstTutorial) {
        this.isFirstTutorial = true
        this.showTutorial = true
      }
    })

    this.$events.on('onHotspotZoom', (position) => {
      if (position && this.viewer) {
        const ip = position.split(',')
        this.viewer.tweenControlCenter(new Vector3(parseInt(ip[0]), parseInt(ip[1]), parseInt(ip[2])), 1000)
        this.zoomCamera(50)
      }
    })

    document.addEventListener('touchend', () => {
      this.onPanoClick()
      this.closeTutorial()
    })

    if (!this.$root.platform.mobile) {
      this.vPressed = false
      this.bPressed = false

      document.addEventListener('keydown', (e) => {
      // console.log(e.code)
        if (e.code === 'KeyV') { this.vPressed = true }
        if (e.code === 'KeyB') { this.bPressed = true }

        if (this.vPressed && this.bPressed) {
          this.showVideoUI = !this.showVideoUI
        }
      })

      document.addEventListener('keyup', (e) => {
        // console.log(e.code)
        if (e.code === 'KeyV') { this.vPressed = false }
        if (e.code === 'KeyB') { this.bPressed = false }
      })

      document.addEventListener('mousedown', (e) => {
        if (this.$route.name !== 'Home') {
          this.isDown = true
        }
      })

      document.addEventListener('mouseup', (e) => {
        this.closeTutorial()
        this.isDown = false
      })
    }
  },

  beforeDestroy () {
    RAF.remove(this.update)
    document.removeEventListener('mousemove', this.onMouseUpdate)
  },

  methods: {
    zoomCamera (targetZoom, onCompleteFunction) {
      if (this.viewer) {
        anime({
          targets: this,
          zoomDefault: targetZoom,
          easing: 'easeInOutQuint',
          duration: 1500,
          update: () => {
            // console.log(this.zoomDefault, this.viewer, targetZoom)
            this.viewer.setCameraFov(this.zoomDefault)
          },
          complete: () => {
            if (onCompleteFunction) {
              onCompleteFunction()
            }
          }
        })
      }
    },
    onVideoFinished () {
      this.showVideoOverlay = false
      this.isOutroVideo = false
    },
    onVideoRemove () {
      this.videoOverlay = null
    },
    onVideoReady () {
      setTimeout(() => {
        this.isVideoReady = true
        this.isLoading = false
        this.$events.emit('isLoadingEnd')
      }, 700)

      if (this.isOutroVideo) {
        setTimeout(() => {
          this.postHotspotClick(this.nextHotspot)
        }, 2000)
      }
    },
    closeTutorial () {
      if (this.isShowingTutorial && !this.showHotspotTutorial) {
        this.showHotspotTutorial = true
      } else {
        this.showTutorial = false
      }
    },
    onPanoClick () {
      // console.log('click')
      // this.closeTutorial()
      if (this.zoomDefault !== this.minZoom) {
        this.zoomCamera(this.minZoom)
      }

      if (this.currentPanorama && this.currentPanorama.videoElement) {
        this.currentPanorama.videoElement.play()
      }
    },

    update () {
      if (this.viewer) {
        this.camRotationY = this.viewer.camera.rotation.y * (180 / Math.PI)
      }
    },

    onMouseUpdate (e) {
      if (this.$route.name === 'Room') {
        const borderExpanded = e.pageY > this.viewPort.height - 100 || e.pageY < 100
        if (!this.isBorderExpanded && borderExpanded) {
          this.$events.emit('onBorderExpanded', true)
        } else if (this.isBorderExpanded && !borderExpanded) {
          this.$events.emit('onBorderExpanded', false)
        }
        this.isBorderExpanded = borderExpanded
      }
    },

    checkVideoPlay () {
      const { video360, video360Mobile } = this.currentRoom
      if ((video360 || video360Mobile) && this.currentPanorama.videoElement) {
        this.currentPanorama.videoElement.play()
      }
    },
    getRoomFloor (slug) {
      let roomfloor = this.$route.params.floor

      if (this.$root.floors) {
        for (let i = 0; i < this.$root.floors.length; i++) {
          const floor = this.$root.floors[i]
          for (let n = 0; n < floor.rooms.length; n++) {
            const room = floor.rooms[n]
            if (room.roomName._slug === slug) {
              roomfloor = floor._slug
              this.currentFloor = floor
            }
          }
        }
      }

      return roomfloor
    },
    hotspotClick (hotspotIn) {
      const hotspot = hotspotIn.hotspot
      this.nextHotspot = hotspot

      if (this.currentRoom.outroVideo && hotspotIn.position.indexOf('novideo') === -1) {
        this.videoOverlay = {
          videoFile: this.currentRoom.outroVideo
        }
        this.$events.emit('isLoadingStart')
        this.isOutroVideo = true
        this.showVideoOverlay = true
      } else {
        this.postHotspotClick(hotspot)
      }

      setTimeout(this.checkVideoPlay, 2000)
    },
    postHotspotClick (hotspot) {
      this.viewer.autoRotate = false

      this.cleanHotspot()

      const roomfloor = this.getRoomFloor(hotspot._slug)

      this.$router.push({
        name: 'Room',
        params: { floor: roomfloor, roomName: hotspot._slug }
      })
    },

    initPano () {
      this.isLoading = true
      this.infospots = []
      this.viewer = new Viewer({
        output: 'console',
        container: this.$refs.pano,
        controlBar: false,
        autoHideInfospot: false,
        // autoRotate: true,
        autoRotateSpeed: 0.2,
        autoRotateActivationDuration: 20000
      })

      this.viewer.OrbitControls.noZoom = true

      const target = new Vector3(0, 0, 0)
      const { x, y, z } = target.normalize()
      this.viewer.camera.position.set(x, -y, -z)
      this.viewer.setCameraFov(this.zoomDefault)

      this.scene = new Scene()
      this.renderer = new CSS3DRenderer()
      this.renderer.setSize(this.viewPort.width, this.viewPort.height)
      this.renderer.domElement.style.position = 'fixed'
      this.renderer.domElement.style.top = 0
      this.renderer.domElement.style.left = 0
      this.renderer.domElement.style.backgroundColor = 'transparent'
      this.$refs.panovideo.appendChild(this.renderer.domElement)

      this.renderer.render(this.scene, this.viewer.getCamera())
      this.viewer.addUpdateCallback(() => {
        this.renderer.render(this.scene, this.viewer.getCamera())
      })

      this.changePano()
    },

    changePano () {
      this.startPreload = false
      // console.log(this.$refs)
      this.showVideoHotspot = false
      this.isPanoLoaded = false
      if (this.currentRoom) {
        this.isLoading = true
        if (!this.showVideoOverlay) {
          this.$events.emit('isLoadingStart')
        }
        // console.log('isloading')
        const { video360, video360Mobile } = this.currentRoom
        if (video360 || video360Mobile) {
          this.currentVideo = this.$root.platform.mobile && video360Mobile ? video360Mobile : video360
          this.newpanorama = new VideoPanorama('/media/' + this.currentVideo.id, { autoplay: true, muted: true, playsinline: true })
          this.newpanorama.addEventListener('updateVideoPlayButton', (e) => {
            // console.log(e, 'videoplaybutton')
          })
        } else {
          if (this.currentRoom.backgroundImage360 && this.$root.isScreenshot) {
            this.newpanorama = new ImagePanorama('/media/' + this.currentRoom.backgroundImage360.id)
          } else if (this.currentRoom.backgroundMobile && this.$root.platform.mobile) {
            this.newpanorama = new ImagePanorama('/media/' + this.currentRoom.backgroundMobile.id)
          } else if (this.currentRoom.backgroundImage360Medium && this.$root.allSettings.mediumQuality) {
            this.newpanorama = new ImagePanorama('/media/' + this.currentRoom.backgroundImage360Medium.id)
          } else {
            this.newpanorama = new ImagePanorama('/media/' + this.currentRoom.backgroundImage360.id)
          }

          this.newpanorama.addEventListener('progress', this.onPanoProgress)
          this.newpanorama.addEventListener('load', this.showPano)
        }

        this.newpanorama.addEventListener('enter-fade-start', () => {
          if (this.currentRoom.initialPoint) {
            const ip = this.currentRoom.initialPoint.split(',')
            this.viewer.tweenControlCenter(new Vector3(parseInt(ip[0]), parseInt(ip[1]), parseInt(ip[2])), 0)
          } else {
            this.viewer.tweenControlCenter(new Vector3(1000, 0, 0), 0)
          }
        })

        const infospot1 = new InfospotSprite(0, this.infoCircle)
        const infospot2 = new InfospotSprite(0, this.infoCircle)
        this.infospots.push(infospot1)
        this.newpanorama.add(infospot1)
        this.infospots.push(infospot2)
        this.newpanorama.add(infospot2)

        if (this.currentRoom.hotspotInfo) {
          // let hotspotRadius = this.currentRoom.hotspotInfo.length > 5 ? 250 : 400

          for (let i = 0; i < this.currentRoom.hotspotInfo.length; i++) {
            const hs = this.currentRoom.hotspotInfo[i]
            // const iconSrc = hs.hotspot.icon ? '/media/' + hs.hotspot.icon.id : DataImage.Info
            if (hs && hs.position) {
              const pos = hs.position.split(',')
              /* if (hs.hotspot && hs.hotspot._slug === 'block') {
                hotspotRadius = 1
              } */

              if (hs && pos[0] && pos[1] && pos[2]) {
                const infospot = new InfospotSprite(1, this.infoCircle)
                infospot.position.set(pos[0], pos[1], pos[2])
                // infospot.position.set(0, -2000, -5000)
                const panel = this.$refs['hotspot-info' + i][0]
                infospot.addHoverElement(panel, 250, false, this.$refs.panohotspot)

                this.infospots.push(infospot)
                this.newpanorama.add(infospot)
              }
            }
          }
        }

        if (this.currentRoom.hotspotMultiProduct) {
          // let hotspotRadius = this.currentRoom.hotspotMultiProduct.length > 5 ? 250 : 400

          for (let i = 0; i < this.currentRoom.hotspotMultiProduct.length; i++) {
            const hs = this.currentRoom.hotspotMultiProduct[i]
            // const iconSrc = hs.hotspot.icon ? '/media/' + hs.hotspot.icon.id : DataImage.Info
            if (hs && hs.position) {
              const pos = hs.position.split(',')
              /* if (hs.hotspot && hs.hotspot._slug === 'block') {
                hotspotRadius = 1
              } */

              if (hs && pos[0] && pos[1] && pos[2]) {
                const infospot = new InfospotSprite(1, this.infoCircle)
                infospot.position.set(pos[0], pos[1], pos[2])
                // infospot.position.set(0, -2000, -5000)
                const panel = this.$refs['hotspot-multiproduct' + i][0]
                infospot.addHoverElement(panel, 250, false, this.$refs.panohotspot)

                this.infospots.push(infospot)
                this.newpanorama.add(infospot)
              }
            }
          }
        }

        // HotspotVideo
        if (this.currentRoom.hotspotGif) {
          this.hotspotVideos = []
          for (let i = 0; i < this.currentRoom.hotspotGif.length; i++) {
            const hsv = this.currentRoom.hotspotGif[i]
            const pos = hsv.position.split(',')

            const vidbox = this.$refs['videobox' + i][0]

            if (vidbox) {
              const videoobject = new CSS3DObject(vidbox)
              videoobject.position.x = pos[0] // 5000.00
              videoobject.position.y = pos[1] // 1173.85
              videoobject.position.z = pos[2] // -1239.23
              // console.log(videoobject)
              videoobject.rotation.x = pos[3] * (Math.PI / 180) // 305 * (Math.PI / 180)
              videoobject.rotation.y = pos[4] * (Math.PI / 180) // 305 * (Math.PI / 180)
              videoobject.rotation.z = pos[5] * (Math.PI / 180) // 305 * (Math.PI / 180)
              this.scene.add(videoobject)
              this.hotspotVideos.push(videoobject)
            }
          }
        }

        // Hotspot Change Room
        if (this.currentRoom.hotspotRoom) {
          for (let i = 0; i < this.currentRoom.hotspotRoom.length; i++) {
            const hs = this.currentRoom.hotspotRoom[i]
            // const iconSrc = hs.hotspot.icon ? '/media/' + hs.hotspot.icon.id : DataImage.Info
            const roomfloor = this.getRoomFloor(hs.hotspot._slug)

            if (!(this.$root.isTmall && (roomfloor === 'ground-floor' || hs.hotspot._slug.indexOf('stairs-first-floor') > -1 || hs.hotspot._slug.indexOf('ground') > -1))) {
              if (hs && hs.position) {
                const pos = hs.position.split(',')
                const arrow = this.floorArrow
                let roomspot = null

                roomspot = new Infospot(1, arrow, true, { x: 0, y: 10000, z: 0 })
                roomspot.position.set(pos[0], pos[1], pos[2])

                const panel = this.$refs['hotspot-room' + i][0]
                roomspot.addHoverElement(panel, 250, false, this.$refs.panohotspot)

                this.infospots.push(roomspot)
                this.newpanorama.add(roomspot)
              }
            }
          }
        }

        if (this.currentRoom.introVideo) {
          this.videoOverlay = {
            videoFile: this.currentRoom.introVideo
          }
          this.showVideoOverlay = true
          this.isVideoReady = false
        } else if (!this.isOutroVideo) {
          this.showVideoOverlay = false
        }

        this.viewer.add(this.newpanorama)
        this.viewer.setPanorama(this.newpanorama)

        if ((video360 || video360Mobile)) {
          this.showPano()
        }

        // Room ambience audio
        this.currentRoom.music
          ? this.$events.$emit('room-has-audio', this.currentRoom.music.id)
          : this.$events.$emit('room-has-no-audio')

        // Room audioguide
        this.currentRoom[this.$language.current + 'Audioguide']
          ? this.$events.$emit('room-has-audioguide', this.currentRoom)
          : this.$events.$emit('room-has-no-audioguide')
      } else {
        this.$router.push({ name: 'Home' })
      }
    },

    onPanoProgress (event) {
      const percentage = event.progress.loaded / event.progress.total * 100
      // console.log(percentage)
      if (percentage >= 100) {
        this.showPano()
        // setTimeout(this.showPano, 1000)
      }
    },

    showPano () {
      this.$emit('panoLoaded')
      this.isPanoLoaded = true

      if (this.showTutorial && (this.$route.params.roomName && this.$route.params.roomName.indexOf('neon') > -1)) {
        setTimeout(() => {
          this.isShowingTutorial = true
        }, 1000)
      }

      this.preloadNextPano()

      this.currentPanorama = this.newpanorama
      const { video360, video360Mobile } = this.currentRoom
      if ((video360 || video360Mobile) && this.currentPanorama.videoElement) {
        this.currentPanorama.videoElement.autoplay = true
        this.currentPanorama.videoElement.muted = true
        this.currentPanorama.videoElement.play()
      }

      /*
      // How far you can orbit vertically, upper and lower limits.Range is 0 to Math.PI radians.
      this.viewer.OrbitControls.minPolarAngle = Math.PI / 3
      this.viewer.OrbitControls.maxPolarAngle = Math.PI * 2 / 3

      // How far you can orbit horizontally, upper and lower limits. If set, must be a sub-interval of the interval [ - Math.PI, Math.PI ].
      this.viewer.OrbitControls.minAzimuthAngle = - Math.PI / 3
      this.viewer.OrbitControls.maxAzimuthAngle = Math.PI / 3
      */
      this.viewer.OrbitControls.minPolarAngle = Math.PI / 3
      this.viewer.OrbitControls.maxPolarAngle = Math.PI * 0.75
      if (this.currentRoom.limitCamera) {
        this.viewer.OrbitControls.minAzimuthAngle = -Math.PI * 0.8
        this.viewer.OrbitControls.maxAzimuthAngle = -Math.PI * 0.35
      } else {
        this.viewer.OrbitControls.minAzimuthAngle = -Infinity
        this.viewer.OrbitControls.maxAzimuthAngle = Infinity
      }

      if (this.currentRoom.customZoom) {
        this.viewer.setCameraFov(this.currentRoom.customZoom)
      } else {
        this.viewer.setCameraFov(this.minZoom)
      }
      // console.log(this.viewer.OrbitControls.minPolarAngle, this.viewer.OrbitControls.maxPolarAngle, this.viewer.OrbitControls.minAzimuthAngle, this.viewer.OrbitControls.maxAzimuthAngle)

      setTimeout(() => {
        if ((this.currentRoom.introVideo && this.isVideoReady) ||
          (!this.currentRoom.introVideo && !this.isOutroVideo) ||
          (!this.currentRoom.introVideo && !this.currentRoom.outroVideo)) {
          this.$events.emit('isLoadingEnd')
          this.isLoading = false
        }

        this.showVideoHotspot = true
      }, 500)
    },

    async preloadNextPano () {
      this.startPreload = true
      if (this.currentRoom.hotspotRoom) {
        for (let i = 0; i < this.currentRoom.hotspotRoom.length; i++) {
          const hs = this.currentRoom.hotspotRoom[i]

          const room = await this.$apollo.query({
            query: GetRoom,
            variables: {
              slug: hs.hotspot._slug
            }
          })

          if (this.startPreload && room.data.Room) {
            const preloadRoom = room.data.Room
            const preloadImg = new Image()
            if (preloadRoom.backgroundMobile && this.$root.platform.mobile) {
              preloadImg.src = '/media/' + preloadRoom.backgroundMobile.id
            } else if (preloadRoom.backgroundImage360Medium && this.$root.allSettings.mediumQuality) {
              preloadImg.src = '/media/' + preloadRoom.backgroundImage360Medium.id
            } else if (preloadRoom.backgroundImage360) {
              preloadImg.src = '/media/' + preloadRoom.backgroundImage360.id
            }
            await preloadImg.decode()
            // console.log('preloaded', preloadImg.src)
          }
        }
      }

      if (this.currentRoom.hotspotInfo) {
        for (let i = 0; i < this.currentRoom.hotspotInfo.length; i++) {
          const hi = this.currentRoom.hotspotInfo[i]

          if (hi.hotspot) {
            this.$apollo.query({
              query: GetHotspotInfo,
              variables: {
                slug: hi.hotspot._slug
              }
            })
          }
        }
      }

      if (this.currentRoom.hotspotMultiProduct) {
        for (let i = 0; i < this.currentRoom.hotspotMultiProduct.length; i++) {
          const hi = this.currentRoom.hotspotMultiProduct[i]

          if (hi.hotspot) {
            this.$apollo.query({
              query: GetHotspotMultiProduct,
              variables: {
                slug: hi.hotspot._slug
              }
            })
          }
        }
      }
    },

    onVideoUpdate (data) {
      // console.log(data)
      if (this.hotspotVideos && this.hotspotVideos[data.index]) {
        const videoobject = this.hotspotVideos[data.index]
        videoobject.position.x = data.px // 5000.00
        videoobject.position.y = data.py // 1173.85
        videoobject.position.z = data.pz // -1239.23
        // console.log(videoobject)
        videoobject.rotation.x = data.rx * (Math.PI / 180) // 305 * (Math.PI / 180)
        videoobject.rotation.y = data.ry * (Math.PI / 180) // 305 * (Math.PI / 180)
        videoobject.rotation.z = data.rz * (Math.PI / 180) // 305 * (Math.PI / 180)
      }
    },

    cleanHotspot () {
      if (this.currentPanorama) {
        for (let i = 0; i < this.infospots.length; i++) {
          this.infospots[i].removeHoverElement()
          this.currentPanorama.remove(this.infospots[i])
          this.infospots[i].dispose()
        }
        this.infospots = []
      }

      if (this.$refs.panohotspot) {
        this.$refs.panohotspot.innerHTML = ''
      }

      if (this.hotspotVideos) {
        for (let i = 0; i < this.hotspotVideos.length; i++) {
          const element = this.hotspotVideos[i]
          if (this.scene && element) {
            this.scene.remove(element)
          }
        }
      }

      if (this.$refs.panovideoui) {
        this.$refs.panovideoui.innerHTML = ''
      }
    },

    cleanPano () {
      if (this.currentPanorama) {
        this.viewer.remove(this.currentPanorama)
        this.currentPanorama.dispose()
      }
    },

    updateZoom (value) {
      if (this.viewer) {
        this.viewer.setCameraFov(this.zoomDefault)
      }
    }
  },

  watch: {
    '$apollo.loading': function (value) {
      if (value) {
        this.isLoading = true
        this.$events.emit('isLoadingStart')
      }
    },
    viewPort () {
      if (this.renderer) {
        this.renderer.setSize(this.viewPort.width, this.viewPort.height)
      }
    }
  },

  apollo: {
    Floors: {
      query: ListFloor,
      skip () {
        return this.$root.floors
      },
      async result () {
        this.$root.floors = this.Floors.items
      }
    },
    Room: {
      query: GetRoom,
      skip () {
        return !this.$route.params.roomName
      },
      variables () {
        return {
          slug: this.$route.params.roomName
        }
      },
      async result () {
        if (!this.currentRoom || this.currentRoom.roomTitle !== this.Room.roomTitle) {
          this.cleanHotspot()
          this.currentRoom = this.Room
          await this.$nextTick()
          if (!this.viewer) {
            this.initPano()
          } else {
            this.changePano()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.panolens {
  position: fixed;
  z-index: 0;
  overflow: hidden;
  cursor: move;
  cursor: grab;
  width: 100%;
  height: 100%;
  transform-origin: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  transition: width 0.5s, height 0.5s, margin 0.5s;

  &.grabbing {
    cursor: grabbing;
  }

  // &.border-expanded {
  //   width: calc(100vw - 250px);
  //   height: calc(100vh - 250px);

  //   .pano-hotspot-container,
  //   .pano-container,
  //   .panovideo-container {
  //     transform: translate(-50px, -50px);
  //   }
  // }

  // &.border-full {
  //   width: 0;
  //   height: 0;

  //   .pano-hotspot-container,
  //   .pano-container,
  //   .panovideo-container {
  //     transform: translate(-50vw, -50vh);
  //   }
  // }
}

.video-overlay,
.panovideo-container,
.pano-hotspot-container,
.pano-container {
  width: 100%;
  transition: transform 0.5s;
  position: fixed;
  top: 0;
  left: 0;
}

.panovideo-container {
  pointer-events: none;

  &.video-blending {
    mix-blend-mode: lighten;
  }
}

.video-overlay,
.panovideo-container,
.pano-container {
  height: 100%;
}

.hotspot-reference {
  position: absolute;
  display: none;
}

.zoom-slider {
  position: fixed;
  top: 0;
  right: 0;
  background-color: $c-white;
}

.mobile .tutorial {
  transform: translate(-50%, -50%);
}

.tutorial {
  position: absolute;
  pointer-events: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  line-height: 1;
  font-size: 14px;

  &::before {
    content: '';
    z-index: 0;
    position: absolute;
    width: 70vw;
    height: 50vh;
    top: 50%;
    left: 50%;
    pointer-events: none;
    transform: translate(-50%, -50%);
    background: radial-gradient(50% 50% at 50% 50%, rgba(29, 28, 28, 0.7) 0%, rgba(29, 28, 28, 0.44) 51.04%, rgba(0, 0, 0, 0) 100%);
  }

  img {
    width: 100px;
    height: 100px;
  }

  h2 {
    @include breakpoint ('xs-only') {
      font-size: 26px;
    }
  }

  .tutorial-content {
    // position: relative;
    width: 100vw;
  }
}

.hotspot-room {
  h4 {
    position: absolute;
    pointer-events: none;
    color: $c-white;
    transform: translate(-50%, 40px);
  }
}

.archetypes-logo {
  transform: scale(0.65);
  fill: $c-white;
}

.video-box {
  display: block !important;

  .box {
    // position: absolute;
    // width: 640px;
    // height: 360px;
    // background-color: #f00;
    // transform: translate(-50%, -50%);
  }

  &.border {
    ::v-deep .player {
      border: 20px solid $c-white;
    }
  }
}

.ui-container {
  z-index: 10;
  position: fixed;
  background-color: $c-white-50;
}
</style>
